import {
  SocialFacebookIcon,
  SocialInstagramIcon,
  SocialPinterestIcon,
  SocialTwitterIcon,
} from '@shipt/design-system-icons'

export const getFooterIcon = (linkName: string) => {
  switch (linkName) {
    case 'facebook':
      return <SocialFacebookIcon />
    case 'instagram':
      return <SocialInstagramIcon />
    case 'pinterest':
      return <SocialPinterestIcon />
    case 'twitter':
      return <SocialTwitterIcon />
    default:
      return null
  }
}
